import React from "react";
import styled from "styled-components";

import GreenPoint from "../../resources/images/icon/greenPoint.svg";
import { _O } from "../../modules/utils";

const Calculate = () => {
  return (
    <BackgroundDiv>
      <HeaderTitle>진료종료</HeaderTitle>
      {/* constent */}
      <ContentBody>
        <AnimateDiv>
          <img src={GreenPoint} />
          <img src={GreenPoint} />
          <img src={GreenPoint} />
        </AnimateDiv>

        <TextArea>
          <TextBold>진료비 정산중</TextBold>
          <TextNoti>정산내역은 예약현황에서 제공됩니다</TextNoti>
        </TextArea>
      </ContentBody>
      {/* constent */}

      {/* bottom */}
      <Bottom>
        <BottomFloatingBtn onClick={() => _O.Open("/")}>예약현황 바로가기</BottomFloatingBtn>
      </Bottom>
      {/* bottom */}
    </BackgroundDiv>
  );
};

const BackgroundDiv = styled.div`
  background: #fff;
`;

const HeaderTitle = styled.div`
  text-align: center;
  width: 100%;
  padding: 0px 0px 8px 0px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(238, 238, 238, 0.93);

  color: #333;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
`;

const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin-left: auto;

  position: relative;
  top: 36.3vh;
`;

const AnimateDiv = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const TextArea = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const TextBold = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 127.273% */
`;

const TextNoti = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const Bottom = styled.div``;

const BottomFloatingBtn = styled.div`
  display: flex;
  height: 20px;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid #333;
  background: #333;
  color: #fff;

  position: fixed;
  width: calc(100% - 32px);
  bottom: 24px;
  margin: 0 16px;
`;

export default Calculate;
